import {Base} from "@/api/Base"

export class OvertimeApplicationGetHistoryApplication extends Base {
    path = "overtimeApplication/getHistoryApplication"
}